export const projectEvents = {
  CREATED: "created",
  UPDATED: "updated",
  DELETED: "deleted",
};

export const getProjectItemActions = (imageNames, handlers) => [
  {
    id: "more_options",
    title: "More options",
    icon: imageNames.MORE_ICON_GREY,
    tooltip: true,
    options: [
      {
        id: "rename",
        title: "Rename",
        icon: imageNames.EDIT_V2,
        action: handlers.onRename,
      },
      {
        id: "open_in_new_tab",
        title: "Open in new tab",
        icon: imageNames.ARROW_OUTWARD,
        action: handlers.onOpenInNewTab,
      },
      {
        id: "delete",
        title: "Delete",
        icon: imageNames.DELETE_GREY,
        action: handlers.onDelete,
      },
    ],
  },
];
